import React from 'react';
import { Button, Typography, Grid, withStyles } from '@material-ui/core';
import Grey from '@material-ui/core/colors/grey';

const styles = {
	root: {
		width: '100%',
		height: '100vh',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		backgroundImage: `linear-gradient(to right, rgba(0,0,0,.2), rgba(0,0,0,0.4)),url('https://i.imgur.com/4GYcECT.png')`,
	},
	container: {
		background: `${Grey[200]}`,
		padding: '20px 40px !important',
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%,-50%)',
		borderRadius: '2px',
	},
	button: {
		borderRadius: '2px',
	},
};

class Login extends React.Component {
	state = {
		isShowingModal: true,
	};

	componentDidMount() {
		const {
			auth: { renewSession },
		} = this.props;

		if (localStorage.getItem('isLoggedIn') === 'true') {
			this.setState({ isShowingModal: false });
			renewSession()
				.then(resolve_result => this.setState({ isShowingModal: resolve_result }))
				.catch(reject_result => this.setState({ isShowingModal: reject_result }));
		}
	}

	render() {
		const { auth, classes } = this.props;
		const { isShowingModal } = this.state;
		return (
			isShowingModal && (
				<Grid container className={classes.root}>
					<Grid item md={6} xs={12} className={classes.container}>
						<Typography variant="h4" style={{ marginBottom: '20px' }}>
							Dashboard App
						</Typography>
						<Typography variant="subtitle1" style={{ marginBottom: '20px' }}>
							This app is a part of{' '}
							<a href="https://reactiveapps.io">Reactive Marketplace</a>.
						</Typography>
						<Typography
							variant="subtitle1"
							style={{ marginBottom: '10px', fontWeight: 'bold' }}
						>
							App Description
						</Typography>
						<Typography variant="subtitle1" style={{ marginBottom: '20px' }}>
							This app contains visualization of sales data of games that were
							published over the years.
						</Typography>
						<Typography
							variant="subtitle1"
							style={{ marginBottom: '10px', fontWeight: 'bold' }}
						>
							Charts Library used
						</Typography>
						<Typography variant="subtitle1" style={{ marginBottom: '20px' }}>
							ReCharts are easy to use as each UI element is a React Component whereas
							in Apex Charts we need to pass them as props.
							<br />- react-apexcharts
							<br />- recharts
							<br />- react-simple-maps
							<br />
						</Typography>
						<Typography
							variant="subtitle1"
							style={{ marginBottom: '10px', fontWeight: 'bold' }}
						>
							Compatible with any Dataset.
						</Typography>
						<Button
							className={classes.button}
							variant="contained"
							color="primary"
							size="large"
							onClick={() => auth.login()}
						>
							Login
						</Button>
					</Grid>
				</Grid>
			)
		);
	}
}

export default withStyles(styles)(Login);
